import React from 'react';
import { isResetOProgram } from 'utils/common';
import { PRESCRIPTION_STATUS } from 'utils/prescription';
import styles from './styles.module.scss';

const StatusBar = ({
  totalDaysUsed,
  daysSubstanceUsedThisMonth,
  daysBupUsedThisMonth,
  prescriptionStatus,
}: {
  totalDaysUsed: number;
  daysSubstanceUsedThisMonth: number;
  daysBupUsedThisMonth: number;
  prescriptionStatus: Nullable<string>;
}) => (
  <div className={styles.wrapper} data-testid="calendar-status-bar">
    <div className={styles.header}>
      <div className={styles.value}>{totalDaysUsed}</div>
      <div className={styles.label}>
        Total days
        <br />
        substance use
      </div>
    </div>
    {prescriptionStatus === PRESCRIPTION_STATUS.STARTED && (
      <div className={styles.header}>
        <div className={styles.value}>{daysSubstanceUsedThisMonth}</div>
        <div className={styles.label}>
          Days substance use
          <br />
          past 30 days
        </div>
      </div>
    )}
    {prescriptionStatus === PRESCRIPTION_STATUS.STARTED &&
      isResetOProgram() && (
        <div className={styles.header}>
          <div className={styles.value}>{daysBupUsedThisMonth}</div>
          <div className={styles.label}>
            Days buprenorphine
            <br />
            use past 30 days
          </div>
        </div>
      )}
  </div>
);

export default StatusBar;
